import { useLocation } from 'react-router'
import { getTenantStorageUrl } from 'shared/utils/url'
import { useTenantBranding } from './useTenantBranding'

/**
 * 認証画面のテナント別配色（sooki の背景・青ボタン・白文字）。
 *
 * テナント判定は `useTenantBranding` に任せる。認証画面では userMe のキャッシュが
 * 空なので URL サブドメインで判定され、以前の URL 直読みと同じ結果になる。
 */
export const useLoginStyle = () => {
  const location = useLocation()
  const { tenantName: tenant } = useTenantBranding()
  const isLoginPage = location.pathname === '/login'
  const isSookiTenant = tenant === 'sooki'
  const isSookiLoginPage = isLoginPage && isSookiTenant
  const tenantStorageUrl = `${getTenantStorageUrl(tenant)}`;

  return {
    isSookiLoginPage,
    textColor: isSookiLoginPage ? 'white' : 'black',
    shouldBeTransparent: isSookiLoginPage,
    buttonColor: isSookiLoginPage ? '#1C8DCA' : undefined,
    // 背景は sooki テナントの全認証ページ(ログイン/パスワード忘れ等)に適用する。
    // ボタン/文字色(#1C8DCA / white)は従来どおりログイン画面限定のまま。
    backgroundStyle: isSookiTenant ? {
      backgroundImage: `url(${tenantStorageUrl}/public/sookibg.svg)`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      minHeight: '100vh'
    } : {}
  }
}
